// extracted by mini-css-extract-plugin
export default {"errorPage":"ErrorPage_errorPage__xeTTK","informationBlock":"ErrorPage_informationBlock__kfxte"};